const bibliography = [
    {
        id: 1,
        author: "Erich Auerbach",
        title: "<i>Mimesis: The Representation of Reality in Western Literature</i>",
        url: "https://en.m.wikipedia.org/wiki/Mimesis:_The_Representation_of_Reality_in_Western_Literature",
        pubDate: "1946"
    },
    {
        id: 2,
        author: "Roger Caillois",
        title: "<i>Mimicry and Legendary Psychasthenia</i>",
        url: "https://eur03.safelinks.protection.outlook.com/?url=https%3A%2F%2Fhiw.kuleuven.be%2Fhua%2Fevents%2Fhom-seminar%2Fsuggested-reading%2F2-caillois-mimicry.pdf&data=05%7C01%7Cnathan.gotlib%40vlaanderen.be%7Cdcb386fdb1214e2b9cbf08da90a51c74%7C0c0338a695614ee8b8d64e89cbd520a0%7C0%7C0%7C637981336741995349%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&sdata=zS0ZpSb7t5cwg4UKsvHC51bEj6%2Fh%2F3p%2FLuu6H72i4bU%3D&reserved=0",
        pubDate: "1938"
    },
    {
        id: 3,
        author: "Lucien Dällenbach",
        title: "<i>Dallenbach: Mirror in the Text</i>",
        url: "https://www.amazon.co.uk/Dallenbach-Mirror-Text/dp/0226134911",
        pubDate: "1989"
    },
    {
        id: 4,
        author: "Paul North",
        title: "<i>Bizarre-Privileged Items in the Universe: The Logic of Likeness</i>",
        url: "https://www.zonebooks.org/books/138-bizarre-privileged-items-in-the-universe-the-logic-of-likeness",
        pubDate: "2021"
    },

    {
        id: 5,
        author: "Gabriel Tarde",
        title: "<i>The Laws of Imitation</i>",
        url: "https://books.google.co.uk/books/about/The_Laws_of_Imitation.html?id=nU59CgAAQBAJ&printsec=frontcover&source=kp_read_button&hl=en&newbks=1&newbks_redir=0&gboemv=1&ovdme=1&redir_esc=y#v=onepage&q&f=false",
        pubDate: "1890"
    },
    {
        id: 6,
        author: "Michael Taussig",
        title: "<i>Mimesis and Alterity: A Particular History of the Senses</i>",
        url: "https://books.google.be/books/about/Mimesis_and_Alterity.html?id=Y9tdDwAAQBAJ&printsec=frontcover&source=kp_read_button&hl=en&redir_esc=y#v=onepage&q&f=false",
        pubDate: "1993"
    }
];

export default bibliography;